import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import AllAssetsCard from '../components/assets/AllAssetsCard';
import RequestAssetModal from '../components/assets/RequestAssetModal';

function AllAssets() {
  const history = useHistory();
  const [showRequestModal, setShowRequestModal] = useState(false);

  const handleGoBack = () => {
    history.push('/assets');
  };

  const handleRequestNewAsset = () => {
    setShowRequestModal(true);
  };

  const handleCloseModal = () => {
    setShowRequestModal(false);
  };

  return (
    <div className="container-fluid">
      <div className="row row-dashboard">
        <div className="col-lg-12">
          <div className="mb-3 d-flex justify-content-between">
            <button
              className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
              onClick={handleRequestNewAsset}
              style={{ gap: '8px', padding: '8px 16px' }}>
              <i className="fas fa-plus"></i> Request new asset
            </button>
            <button
              className="btn btn-primary btn-sm d-flex align-items-center justify-content-center"
              onClick={handleGoBack}
              style={{ gap: '8px', padding: '8px 16px' }}>
              <i className="fas fa-arrow-left"></i> Go back
            </button>
          </div>
          <AllAssetsCard />
        </div>
      </div>

      <RequestAssetModal show={showRequestModal} onClose={handleCloseModal} />
    </div>
  );
}

export default AllAssets;
